import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router'
import { EnumSpinnerLoaderPosition, SpinnerLoader } from 'shared/ui'
import { logger } from 'shared/lib'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import {
  type IResponseBroadcastById,
  type IResponseOneTimeBroadcast,
  type IResponseRecurringBroadcastById,
} from 'entities/Broadcast/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { BroadcastView, BroadcastViewStore } from 'pages/broadcasts/ui/BroadcastView'

const SuccessContent = ({
  broadcastResponse,
  isDuplicate,
}: {
  broadcastResponse: IResponseOneTimeBroadcast | IResponseRecurringBroadcastById
  isDuplicate?: boolean
}) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new BroadcastViewStore(entities, broadcastResponse, isDuplicate))
  return <BroadcastView store={store} />
}

type IEditBroadcastProps = {
  isDuplicate?: boolean
}

export const EditBroadcast = ({ isDuplicate }: IEditBroadcastProps) => {
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [broadcastResponse, setBroadcastResponse] = useState<IResponseBroadcastById | null>(null)
  const entities = useEntitiesContext()

  useEffect(() => {
    if (id) {
      Promise.all([
        entities.broadcastStore.getItemById(id),
        entities.inboxesStore.fetchSmartInboxes(),
        entities.numbersStore.fetchNumbersShortCodes(),
      ])
        .then(([res]) => {
          if (res) {
            setBroadcastResponse(res.data)
          }
        })
        .catch(logger.error)
        .finally(() => {
          setLoading(false)
        })
    }
  }, [id])

  if (loading) {
    return (
      <SpinnerLoader ariaLabel={'EditBroadcast'} position={EnumSpinnerLoaderPosition.Absolute} />
    )
  }
  if (broadcastResponse) {
    return <SuccessContent broadcastResponse={broadcastResponse} isDuplicate={isDuplicate} />
  }
  return <Navigate to={`/${BroadcastsRoutes.root}/${BroadcastsRoutes.all}`} />
}
